const base_url = "https://youthlab.sdut.edu.cn";

export const serviceUrl = {
  freshman: base_url + "/app/wechat-service/freshman/index.html#/", // 新生信息查询
  jidian: base_url + "/app/wechat-service/jd/#/login", // 绩点
  ecard: base_url + "/app/wechat-service/ecard/", // 一卡通
  elec: "http://hqfw.sdut.edu.cn/stu_elc.aspx", // 用电查询
  hygiene: base_url + "/app/wechat-service/hygiene/index.html#/", // 宿舍卫生
  exam: base_url + "/app/wechat-service/exam/index.html#/", // 考试时间
  ncre: "http://cjcx.neea.edu.cn/ncre/query.html", //  计算机等级
  cet: "http://cet.neea.edu.cn/cet/", // 四六级成绩
  cert: base_url + "/app/wechat-service/cert/#/", // 教师资格证
  pth: "http://youth.sdut.edu.cn/wechat/pth/", // 普通话
  calendor: base_url + "/app/wechat-service/calendar", // 校历
  bus: base_url + "/app/wechat-service/bus", // 班车
  qj: "http://720yun.com/t/49f29wa5wbs" // 全景
};
